import type { ReactNode } from 'react'

type SectionHeaderProps = {
  title?: string
  /** Optional control aligned to the right of the title (e.g. a "Browse all plans" link). */
  trailing?: ReactNode
}

export default function SectionHeader({ title = 'Connected Accounts', trailing }: SectionHeaderProps) {
  return (
    <div className="flex h-11 min-h-11 items-center gap-3 border-b border-border-default px-4 py-2">
      <p className="min-w-0 flex-1 text-sm font-semibold leading-5 text-brand-neutral-500">{title}</p>
      {trailing}
    </div>
  )
}
